/**
 * BLOCK - COOKIES
 */

// Load the Customer Privacy API
window.Shopify.loadFeatures([
  {
    name: 'consent-tracking-api',
    version: '0.1',
  }
],
function(error) {
  if (error) throw error;
  checkCookies();
});


// Checks if the cookies banner should be displayed
window.checkCookies = function (e) {
  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
  const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

  if ((!userCanBeTracked && userTrackingConsent === 'no_interaction') || Shopify.designMode) showBanner();
}  

/**
 * BLOCK - COOKIES - LISTENERS
 */

setupEventListenersForCookies();

// Creates the event listeners
function setupEventListenersForCookies() {
  // On clicking on a link or on the "I understand" button of the cookie banner
  document.querySelectorAll('[data-action="accept-cookies"]').forEach((element) => {
    element.addEventListener('click', acceptCookies);
  });
  
  // On clicking on a cross or on the "I decline" button of the cookie banner
  document.querySelectorAll('[data-action="decline-cookies"]').forEach((element) => {
    element.addEventListener('click', declineCookies);
  });
}

/**
 * BLOCK - COOKIES - GENERAL
 */

// Accepts cookies
function acceptCookies(event) {
  var href = this.getAttribute('href');

  event.preventDefault();
  window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

  document.addEventListener('trackingConsentAccepted', () => {
    console.log('trackingConsentAccepted event fired');
  });
  
  href != '#' && href != '#accept-cookies' && href != '#decline-cookies' ? window.location.href = href : event.preventDefault();
}

// Declines cookies
function declineCookies(event) {
  var href = this.getAttribute('href');

  event.preventDefault();
  window.Shopify.customerPrivacy.setTrackingConsent(false, hideBanner);
  
  href != '#' && href != '#accept-cookies' && href != '#decline-cookies' ? window.location.href = href : event.preventDefault();
}

// Hides the cookies banner
function hideBanner() {  
  hideBand(document.getElementsByClassName('shopify-section__cookies-bar')[0]);
}

// Shows the cookies banner
function showBanner() {  
  showBand(document.getElementsByClassName('shopify-section__cookies-bar')[0]);
}